import React from "react";
import classNames from "classnames";
// import RcInputNumber from '../../_rc-input-number-4.0.1/src';
import Loadable from "../../react-loadable";
const RcInputNumber = Loadable({
  loader: () => import("../../_rc-input-number-4.0.1/src"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
export default class InputNumber extends React.Component {
  static defaultProps = {
    prefixCls: "ant-input-number",
    step: 1
  };

  render() {
    const { className, size, ...other } = this.props;
    const inputNumberClass = classNames({
      [`${this.props.prefixCls}-lg`]: size === "large",
      [`${this.props.prefixCls}-sm`]: size === "small",
      [className]: !!className
    });

    return <RcInputNumber className={inputNumberClass} {...other} />;
  }
}



// WEBPACK FOOTER //
// ./_antd1.11.2/input-number/index.jsx